module.exports = __webpack_public_path__ + "static/media/applemessage.4a53efc6.svg";